(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1113],{

/***/ 15746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21584);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 71230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3873);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 41254:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-messages/sent",
      function () {
        return __webpack_require__(31568);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Link */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22745);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  &,\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Link = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.attrs */ .ZP.a.attrs({
    target: "_blank",
    rel: "noreferrer"
})(_templateObject(), _colors__WEBPACK_IMPORTED_MODULE_1__.B1);
Link.propTypes = {
    href: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 53848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ ListPlaceholder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95507);
/* harmony import */ var _tidb_community_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33358);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _pingcap_inc_tidb_community_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68664);
/* harmony import */ var _api_asktug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93236);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59874);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  // center a placeholder image\n  background-image: url('",
        "');\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 120px;\n  //margin-top: 4rem;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var Link = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_tidb_community_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject());
var PlaceHolder = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject1(), _utils__WEBPACK_IMPORTED_MODULE_3__/* .cdn.getImageUrl */ .cK.getImageUrl("/images/list-placeholder.svg"));
function ListPlaceholder(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            fontSize: 14,
            textAlign: "center",
            width: "100%",
            height: 600,
            background: "#F7F8F9",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlaceHolder, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        fontSize: 16,
                        color: _pingcap_inc_tidb_community_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.F2 */ .O9.F2,
                        marginTop: "1rem"
                    },
                    children: text
                })
            ]
        })
    });
}
var PrivateMessages = function(param) {
    var messages = param.messages;
    if (!messages || messages.length === 0) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListPlaceholder, {
        text: "\u8FD8\u6CA1\u6709\u79C1\u4FE1\u54E6"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        pagination: {
            onChange: function(page) {
                console.log(page);
            },
            pageSize: 10
        },
        dataSource: messages,
        renderItem: function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Item */ .ZP.Item, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Item.Meta */ .ZP.Item.Meta, {
                        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Link, {
                            href: "".concat(_api_asktug__WEBPACK_IMPORTED_MODULE_2__.askTugDomain, "/t/topic/").concat(item.id),
                            children: item.fancy_title
                        }),
                        description: item.users.reduce(function(acc, user) {
                            return acc + user.username + " ";
                        }, "")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            color: "#8C8C8C"
                        },
                        children: new Date(item.last_posted_at).toLocaleDateString("zh-Hans-CN")
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrivateMessages);


/***/ }),

/***/ 95202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ usePrivateMessages; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62675);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8100);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89590);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36486);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var usePrivateMessages = function(sent) {
    var meData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .MeContext */ .io).meData;
    var data = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)((meData === null || meData === void 0 ? void 0 : meData.username) ? [
        "asktug.getPrivateMessages" + (sent ? "Sent" : ""),
        {
            username: meData === null || meData === void 0 ? void 0 : meData.username
        }
    ] : null, {
        fetcher: _api__WEBPACK_IMPORTED_MODULE_3__/* .fetcher */ ._i
    }).data;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var messages = undefined;
        if (data && data.users) {
            var userLookup = ramda__WEBPACK_IMPORTED_MODULE_4__/* .indexBy */ .HK3(ramda__WEBPACK_IMPORTED_MODULE_4__/* .prop */ .vgT("id"))(data.users);
            var _user_id;
            messages = ramda__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UID(function(x) {
                return _objectSpread({
                    users: ramda__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UID(function(i) {
                        return (_user_id = userLookup[i.user_id]) !== null && _user_id !== void 0 ? _user_id : "unknown";
                    }, x.posters)
                }, x);
            }, data.topic_list.topics);
        }
        return messages;
    }, [
        data
    ]);
};


/***/ }),

/***/ 22524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Layout_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/private-messages/layout/layout.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), mixins/* responsive */.jW());
var Main = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());

// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/private-messages/layout/menu/menu.styled.ts
function menu_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function menu_styled_templateObject() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin-top: 1rem;\n  ",
        ";\n  background: ",
        ";\n  list-style: none;\n  border: 1px solid ",
        ";\n"
    ]);
    menu_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_styled_templateObject1() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n      cursor: default;\n      border-left: 3px solid ",
        ";\n      background: ",
        " !important;\n    "
    ]);
    menu_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n      padding-left: 2rem;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  justify-content: space-between;\n  padding: 0 1rem;\n  cursor: pointer;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var menu_styled_Container = styled_components_browser_esm/* default.ul */.ZP.ul(menu_styled_templateObject(), mixins/* reset */.mc(), mixins/* typography */.cp("p2"), colors.M1, colors.T2);
var Item = styled_components_browser_esm/* default.li */.ZP.li(_templateObject3(), mixins/* flexVerticalCenter */.VL(), mixins/* verticalLineMiddle */.XK("2.5rem"), colors.T2, colors.M2, function(props) {
    return props.isActive && (0,styled_components_browser_esm/* css */.iv)(menu_styled_templateObject1(), colors.B1, colors.M1);
}, function(props) {
    return props.indent && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/pages/private-messages/layout/menu/Menu.component.tsx





var Menu = function() {
    var router = (0,next_router.useRouter)();
    // get the current page
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_styled_Container, {
        children: list.map(function(item) {
            var href = "/private-messages".concat(item.key);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    isActive: router.pathname === href,
                    children: item.title
                })
            });
        })
    });
};
var list = [
    {
        key: "",
        title: "\u6536\u4EF6\u7BB1",
        isActive: false
    },
    {
        key: "/sent",
        title: "\u5DF2\u53D1\u9001",
        isActive: false
    }, 
];
/* harmony default export */ var Menu_component = (Menu);

;// CONCATENATED MODULE: ./src/pages/private-messages/layout/menu/index.ts


// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./src/layouts/index.js + 13 modules
var layouts = __webpack_require__(59269);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MailOutlined.js + 1 modules
var MailOutlined = __webpack_require__(88641);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
;// CONCATENATED MODULE: ./src/pages/private-messages/layout/Layout.component.tsx










var Layout = function(param) {
    var children = param.children;
    var ref = (0,react.useContext)(context/* AuthContext */.Vo), isAnonymous = ref.isAnonymous, login = ref.login;
    var router = (0,next_router.useRouter)();
    if (isAnonymous) {
        login();
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* SiteLayout */.I, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                    title: "\u79C1\u4FE1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        gutter: [
                            32,
                            32
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                xs: 24,
                                sm: 8,
                                md: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                            type: "primary",
                                            style: {
                                                width: "100%"
                                            },
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MailOutlined/* default */.Z, {}),
                                            onClick: function() {
                                                return router.push("https://asktug.com/new-message");
                                            },
                                            children: "\u5199\u65B0\u79C1\u4FE1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_component, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                sm: 16,
                                md: 18,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                                    children: children
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Layout_component = (Layout);

;// CONCATENATED MODULE: ./src/pages/private-messages/layout/index.ts



/***/ }),

/***/ 31568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22524);
/* harmony import */ var _PrivateMessages_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53848);
/* harmony import */ var _pages_private_messages_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95202);

// @ts-ignore



var __N_SSG = true;
function Page() {
    var messages = (0,_pages_private_messages_hooks__WEBPACK_IMPORTED_MODULE_3__/* .usePrivateMessages */ .V)(true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateMessages_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        messages: messages
    });
};
Page.Layout = _layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(41254); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);